import HinhThucMienGiamGroupPage from "./HinhThucMienGiamGroupPage";

export default HinhThucMienGiamGroupPage